/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreBookmark = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M11.411 0h-7C3.033 0 2 1.121 2 2.5V15c0 .191.064.365.236.449s.354.063.505-.055l5.181-4.056 5.187 4.056a.495.495 0 0 0 .305.105.694.694 0 0 0 .262-.051c.172-.084.324-.258.324-.449v-12.5c0-1.379-1.211-2.5-2.589-2.5zm-.763 9.937L7.911 7.903 5.174 9.869 6.22 6.82 3.483 5h3.384l1.046-3.218L8.959 5h3.383L9.605 6.809l1.046 3.128z"
    />
  </svg>
);

IconCoreBookmark.displayName = 'IconCoreBookmark';

IconCoreBookmark.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreBookmark);
IconCoreBookmark.displayName = 'IconCoreBookmark';
